export default (examName: string, sections: string) => {
  if (examName === 'GMAT') {
    if (!sections || sections === 'all') {
      return [
        { name: 'Quantitative Reasoning', value: 100 },
        { name: 'Verbal Reasoning', value: 100 },
        { name: 'Data Insights', value: 100 }
      ];
    }

    let result = [];

    if (sections.indexOf('quantitative_reasoning') !== -1){
      result.push({ name: 'Quantitative Reasoning', value: 100 });
    }
    if (sections.indexOf('verbal_reasoning') !== -1) {
      result.push({ name: 'Verbal Reasoning', value: 100 });
    }
    if (sections.indexOf('data_insights') !== -1) {
      result.push({ name: 'Data Insights', value: 100 });
    }

    return result;
  } else if (examName === 'GRE') {
    if (!sections || sections === 'all') {
      return [
        { name: 'Math', value: 100 },
        { name: 'Verbal', value: 100 }
      ];
    }

    let result = [];

    if (sections.indexOf('math') !== -1){
      result.push({ name: 'Math', value: 100 });
    }
    if (sections.indexOf('verbal') !== -1) {
      result.push({ name: 'Verbal', value: 100 });
    }

    return result;
  } else if (examName === 'SAT') {
    if (!sections || sections === 'all') {
      return [
        { name: 'Reading & Writing', value: 100 },
        { name: 'Math', value: 100 }
      ];
    }

    let result = [];

    if (sections.indexOf('reading_and_writing') !== -1) {
      result.push({ name: 'Reading & Writing', value: 100 });
    }
    if (sections.indexOf('math') !== -1){
      result.push({ name: 'Math', value: 100 });
    }

    return result;
  } else if (examName === 'TOEFL') {
    if (!sections || sections === 'all') {
      return [
        { name: 'Reading', value: 100 },
        { name: 'Listening', value: 100 },
        { name: 'Speaking', value: 100 },
        { name: 'Writing', value: 100 }
      ];
    }

    let result = [];

    if (sections.indexOf('reading') !== -1) {
      result.push({ name: 'Reading', value: 100 });
    }
    if (sections.indexOf('listening') !== -1){
      result.push({ name: 'Listening', value: 100 });
    }
    if (sections.indexOf('speaking') !== -1){
      result.push({ name: 'Speaking', value: 100 });
    }
    if (sections.indexOf('writing') !== -1){
      result.push({ name: 'Writing', value: 100 });
    }

    return result;
  } else {
    return [];
  }
};
